<app-loading-container [loading]="loading">
    <div [formGroup]="form" class="u-flex-column">
        <h2 class="u-font-size-24 u-margin-bottom">Water transfer document</h2>
        <div class="u-w100p u-padding u-border-radius u-margin-bottom u-background-gray-ultralight">
            <h3 class="u-margin-bottom-xs u-font-size-20 u-color-gray-ultradark">{{ 'TRANSACTION.LABEL' | translate }}</h3>
            <div class="u-flex-column u-margin-top">
                <app-water-supplier-input
                    [formControlName]="waterDetailFields.WaterSupplier"
                    (supplierChanged)="onSupplierChanged($event)"
                ></app-water-supplier-input>
                <div class="u-flex-row">
                    <span class="u-color-gray-dark u-font-size-12"
                    >{{ 'ADMIN.DASHBOARD.DETAIL.WATER_DETAILS.SUPPLIER.NOTE' | translate }}</span
                    >
                    <a class="u-font-size-12 u-margin-left-quarter" [href]="lookupToolUrl" target="_blank"
                    >{{ 'ADMIN.DASHBOARD.DETAIL.WATER_DETAILS.SUPPLIER.LINK' | translate }}</a
                    >
                </div>
            </div>
        </div>

        <app-water-meter-form class="u-display-block u-margin-bottom" [parentForm]="form"></app-water-meter-form>

        <app-leaver-form class="u-display-block u-margin-bottom" [parentForm]="form"
                         [leaverPresent]="!!leaver"></app-leaver-form>

        <app-transferee-form [parentForm]="form" class="u-display-block u-margin-bottom"></app-transferee-form>

        <app-water-assets-form
            class="u-display-block u-margin-bottom"
            [transactionId]="DbUtils.getStringId(transferee)"
            [title]="'V2.SERVICES.WATER.ASSETS.TRANSFER_DOCUMENT.TITLE' | translate"
            [buttonLabel]="'V2.SERVICES.WATER.ASSETS.TRANSFER_DOCUMENT.BUTTON' | translate"
            [buttonDisabled]="waterTransferDocumentServiceStore.hasAssetWaterTransferDocument()"
            [hideRemove]="waterTransferDocumentServiceStore.hasAssetWaterTransferDocument()"
            [assetType]="WaterTransferAssetType.TransferDocument"
            (assetUploaded)="onAssetChanged()"
            (assetDeleted)="onAssetChanged()"
        >
            <ng-container header-right>
                <app-check-input
                    [custom]="false"
                    [labelPosition]="UiLabelPosition.After"
                    ngDefaultControl
                    style="flex: 0 50%"
                    [option]="transferDocumentCompleteOption"
                    [formControlName]="waterDetailFields.TransferDocumentComplete"
                    [hasMargin]="false"
                ></app-check-input>
            </ng-container>
            <ng-container buttons>
                <button
                    id="generate-button"
                    [disabled]="waterTransferDocumentServiceStore.hasAssetWaterTransferDocument()"
                    class="u-margin-left"
                    smvd-ui-button
                    [context]="uiContext.PrimaryDark"
                    (click)="onGenerateWaterTransferDocument()"
                >
                    {{ 'GENERATE' | translate }}
                </button>
            </ng-container>
        </app-water-assets-form>

        <h2 class="u-font-size-24 u-margin-y-axis">Attachments <span class="u-color-gray">(optional)</span></h2>
        <app-water-assets-form
            class="u-display-block u-margin-bottom"
            [title]="'V2.SERVICES.WATER.ASSETS.METER_PICTURES.TITLE' | translate"
            [buttonLabel]="'V2.SERVICES.WATER.ASSETS.METER_PICTURES.BUTTON' | translate"
            [transactionId]="DbUtils.getStringId(transferee)"
            [assetType]="WaterTransferAssetType.MeterPictures"
        >
        </app-water-assets-form>

        <div class="grid grid-cols-2 gap-4">
            <app-water-assets-form
                [title]="'V2.SERVICES.WATER.ASSETS.ID_CARD_PICTURES.TITLE' | translate"
                [buttonLabel]="'V2.SERVICES.WATER.ASSETS.ID_CARD_PICTURES.BUTTON' | translate"
                [transactionId]="DbUtils.getStringId(transferee)"
                context="secondary"
                class="h-full"
                [assetType]="WaterTransferAssetType.IDCardPictures"
            >
            </app-water-assets-form>

            <app-water-assets-form
                [title]="'V2.SERVICES.WATER.ASSETS.OTHER_ATTACHMENTS.TITLE' | translate"
                [buttonLabel]="'V2.SERVICES.WATER.ASSETS.OTHER_ATTACHMENTS.BUTTON' | translate"
                [transactionId]="DbUtils.getStringId(transferee)"
                context="secondary"
                class="h-full"
                [assetType]="WaterTransferAssetType.Attachment"
            >
            </app-water-assets-form>
        </div>

        <div class="u-flex-row u-flex-justify-content-flex-end u-margin-top-double">
            <button
                id="submit-button"
                smvd-ui-button
                [disabled]="form.pristine"
                [context]="uiContext.PrimaryDark"
                class="__button-save"
                (click)="saveWaterDetails()"
            >
                {{ 'SAVE' | translate }}
            </button>
        </div>
    </div>
</app-loading-container>
